module.exports = __webpack_public_path__ + "img/QQ.dc1844eb.svg";